import { useLocation, useNavigate } from "react-router-dom";
import MUITable from "../../../../../Common/MUITable";
import { useTripStore } from "../../store/useTripStore";
import { TableLoader } from "../../../../../Common/ShimmerLoader";
import { ExportSATTotalTripReport } from "./ExportSATTotalTripReport";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";
import { Modal } from "react-bootstrap";
import { useState } from "react";

const SATTotalTripReport = () => {
  const { tripDetails, isFetchingTripDetails } = useTripStore();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const columns = [
    {
      label: "Zone",
      field: "zone",
    },
    {
      label: "Cirlce",
      field: "circle",
    },
    {
      label: "Ward",
      field: "ward",
    },
    {
      label: "Vehicle Type",
      field: "vehicleType",
    },
    {
      label: "Vehicle Number",
      field: "vehicleNumber",
    },
    {
      label: "TS Name",
      field: "transferStationName",
    },
    {
      label: "Driver Name",
      field: "driverName",
    },
    {
      label: "Contact No",
      field: "driverNumber",
    },
    {
      label: "SFA Name",
      field: "primaryDeploymentInchargeName",
    },
    {
      label: "SFA Contact No",
      field: "primaryDeploymentInchargeMobileNumber",
    },
    {
      label: "Trips to TS/SCTP",
      field: "trips",
      render: row => row.trips
    },
    {
      label: "TS/SCTP Name",
      field: "transferStationName",
    },
    {
      label: "Deployment Image",
      field: "transferStationScannedImage",
      render: (row) => {
        return (
          row.transferStationScannedImage ? (
            <img
              src={row.transferStationScannedImage}
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.transferStationScannedImage)}
            />
          ) : "N/A"
        )
      }
    },
    // {
    //   label: "Updated By",
    //   field: "deploymentDate",
    //   render: row => row.deploymentDate ? formatDateTime(row.deploymentDate) : "N/A"
    // },
    {
      label: "Reported Time",
      field: "scannedDateTime",
      render: row => row.scannedDateTime ? formatDateTime(row.scannedDateTime) : "N/A"
    },
  ];

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };
  return (
    <>
      <div className="content">
        <div className="page-content">
          <div className="page-header">
            <div className="card">
              <div className="card-body">
                <div class="d-flex justify-content-end mt-3 mb-3">
                  <button
                    class="btn btn-secondary  me-2"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <ExportSATTotalTripReport data={state} />
                </div>
                <div class="top-header">
                  <span>{state.circleName || ""} {state.zoneName || ""} Total Trips ({formatDateTimeWithoutSec(state.FromDateTime)} To {formatDateTimeWithoutSec(state.ToDateTime)}) (at {getCurrentDateTime1()})</span>
                </div>
                <div>
                  <MUITable
                    needSRNumber
                    rows={tripDetails}
                    columns={columns}
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton><Modal.Title>Image Full Preview</Modal.Title></Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Full vehicle" style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default SATTotalTripReport;